import { render, staticRenderFns } from "./AdvGiftChoiceModal.vue?vue&type=template&id=00424e4c"
import script from "./AdvGiftChoiceModal.vue?vue&type=script&lang=js"
export * from "./AdvGiftChoiceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports